export default __webpack_public_path__ + "static/media/04.38354331.jpg";